import { AuthXInterceptor } from '../Config/AuthXInterceptor'

export const boostPromoStationBXService = {
  // Get all boost promo stations
  index: async () => {
    return await AuthXInterceptor.get('bnpm-promo/stations')
  },

  // Add station to promo list
  addStation: async (stationId: string) => {
    return await AuthXInterceptor.post(`bnpm-promo/stations/${stationId}`)
  },

  // Remove station from promo list
  removeStation: async (stationId: string) => {
    return await AuthXInterceptor.delete(`bnpm-promo/stations/${stationId}`)
  },
}
